<template>
  <div class="checkout-section-inner">
    <form
      id="shipping-details-form"
      @submit.prevent="saveDetails"
    >
      <div class="form-group">
        <label
          for="shipping-method"
          class="control-label"
        >Shipping method</label>
        <select
          id="shipping-method"
          v-model="shippingDetails.method"
          required
          class="form-control"
        >
          <option
            v-if="allowedMethods.pickup_enabled"
            value="pickup"
          >
            Local pickup
          </option>
          <option
            v-if="allowedMethods.standard_postage_enabled"
            value="standard_postage"
          >
            Standard Postage (+${{ allowedMethods.standard_postage_cost }})
          </option>
          <option
            v-if="allowedMethods.express_postage_enabled"
            value="express_postage"
          >
            Express Postage (+${{ allowedMethods.express_postage_cost }})
          </option>
          <option
            v-if="allowedMethods.bulky_postage_enabled"
            value="bulky_postage"
          >
            Bulky Items Postage (+${{ allowedMethods.bulky_postage_cost }})
          </option>
        </select>
      </div>

      <div v-if="shippingDetails.method == 'pickup'">
        <div class="checkout-note-box">
          <strong>Instructions</strong>
          <p>{{ pickupInstructions }}</p>
        </div>

        <div class="form-group">
          <div class="checkboxes">
            <label>
              <input
                id="pickup-agreed"
                v-model="pickupAgreed"
                type="checkbox"
              >
              <span> I understand the instructions above and will be able to pickup my order</span>
            </label>
          </div>
        </div>
      </div>

      <div v-if="shippingDetails.method !== 'pickup' && shippingDetails.method">
        <div class="form-group">
          <label
            for="unit-number"
            class="control-label"
          >Unit number</label>
          <input
            id="unit-number"
            v-model="shippingDetails.unitNumber"
            type="text"
            class="form-control"
          >
        </div>

        <div class="form-group">
          <label
            for="street_number"
            class="control-label"
          >Street Number</label>
          <input
            id="street_number"
            v-model="shippingDetails.streetNumber"
            required
            type="text"
            class="form-control"
          >
        </div>

        <div class="form-group">
          <label
            for="street_name"
            class="control-label"
          >Street name</label>
          <input
            id="street_name"
            v-model="shippingDetails.streetName"
            required
            type="text"
            class="form-control"
          >
        </div>

        <div class="form-group">
          <label
            for="suburb"
            class="control-label"
          >Suburb</label>
          <input
            id="suburb"
            v-model="shippingDetails.suburb"
            required
            type="text"
            class="form-control"
          >
        </div>

        <div class="form-group">
          <label
            for="state"
            class="control-label"
          >State</label>
          <select
            id="state"
            v-model="shippingDetails.state"
            required
            class="form-control"
          >
            <option value="New South Wales">
              New South Wales
            </option>
            <option value="Victoria">
              Victoria
            </option>
            <option value="Queensland">
              Queensland
            </option>
            <option value="Western Australia">
              Western Australia
            </option>
            <option value="South Australia">
              South Australia
            </option>
            <option value="Tasmania">
              Tasmania
            </option>
            <option value="Northern Territory">
              Northern Territory
            </option>
            <option value="ACT">
              ACT
            </option>
          </select>
        </div>

        <div class="form-group">
          <label
            for="post-code"
            class="control-label"
          >Post code</label>
          <input
            id="post-code"
            v-model="shippingDetails.postCode"
            required
            type="number"
            class="form-control"
          >
        </div>
      </div>

      <button
        id="next"
        type="submit"
        class="btn btn-secondary"
        :disabled="(shippingDetails.method == 'pickup' && !pickupAgreed) ? true : false"
      >
        <i class="fas fa-arrow-circle-right" />
        Next
      </button>
    </form>
  </div>
</template>
<script>
import {addShippingDetails} from "../../../shopfront/cartDataService";
export default {
  props: {
    cartPid: { type: String, required: true },
    pickupInstructions: { type: String, required: true },
    checkoutPreferences: { type: Object, required: true },
  },
  data() {
    return {
      shippingDetails: {},
      pickupAgreed: false,
      allowedMethods: this.checkoutPreferences.allowed_shipping_methods,
    };
  },
  methods: {
    saveDetails: function() {
      let vm = this;
      addShippingDetails(this.cartPid, this.$store.state.sellerPid, this.shippingDetails, function() {
        vm.$store.dispatch('refreshCart');
        vm.$emit('sectionComplete');
      });
    },
  },
};
</script>

